import React from "react";


const getIconByName = (iconName = "") => {
  if (!iconName) return null; // Evita errores con valores null o undefined

  // Convertir el nombre del icono a minúsculas para evitar errores
  const lowerCaseIconName = iconName.toLowerCase();

  // Lista de estilos disponibles en Material Symbols y Material Icons
  const styles = ["outlined", "round", "sharp", "two-tone"];
  let selectedStyle = "material-symbols-outlined"; // Por defecto usa Material Symbols

  // Buscar si el nombre del icono contiene un estilo específico
  styles.forEach((style) => {
    if (lowerCaseIconName.includes(`_${style}`)) {
      selectedStyle = `material-icons-${style}`;
    }
  });

  // Si el icono pertenece a Material Icons clásicos, cambia el estilo
  if (!lowerCaseIconName.includes("_")) {
    selectedStyle = "material-icons"; // Iconos clásicos
  }

  return (
    <span
      className={selectedStyle}
      style={{ fontSize: "24px", color: "#00b96b" }}
      data-fill="0"
      data-wght="400"
      data-grad="0"
      data-opsz="24"
    >
      {lowerCaseIconName.replace(/_(outlined|round|sharp|two-tone)$/, "")}
    </span>
  );
};

export default getIconByName;